var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { markEditorFocused, markEditorInactive } from './actionCreators';
import { reduxKey } from './constants';
var actionHandlers = handleActions((_a = {},
    _a[markEditorFocused.toString()] = function (state, _a) {
        var _b;
        var payload = _a.payload;
        return payload ? __assign(__assign({}, state), (_b = {}, _b[payload.editorKey] = { isActive: true }, _b)) : state;
    },
    _a[markEditorInactive.toString()] = function (state, _a) {
        var _b;
        var payload = _a.payload;
        return payload ? __assign(__assign({}, state), (_b = {}, _b[payload.editorKey] = { isActive: false }, _b)) : state;
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducers.js.map